import { useEffect, useRef, useState } from "react";
import api from "../services/api";
import { getSocket } from "../services/socket-io";

// feat_410 — cantidad de consultas de Soporte con respuesta nueva del equipo (insignia del
// menú del cliente). Se refresca con la señal `support` de la room de la empresa y con el
// evento de ventana `support:seen` (lo dispara el hilo al abrirse). Socket singleton:
// solo `off` en el cleanup, nunca disconnect.
const useSupportUnread = (enabled) => {
  const [count, setCount] = useState(0);
  const timer = useRef(null);

  useEffect(() => {
    if (!enabled) return undefined;
    let active = true;
    const load = () =>
      api
        .get("/support/unread")
        .then(({ data }) => active && setCount(Number(data.count) || 0))
        .catch(() => undefined);
    load();
    const later = () => {
      if (timer.current) clearTimeout(timer.current);
      timer.current = setTimeout(load, 600);
    };
    const socket = getSocket();
    socket.on("support", later);
    window.addEventListener("support:seen", later);
    return () => {
      active = false;
      socket.off("support", later);
      window.removeEventListener("support:seen", later);
      if (timer.current) clearTimeout(timer.current);
    };
  }, [enabled]);

  return count;
};

export default useSupportUnread;
